export default {
  computed: {
    vehiclesQuickFilters() {
      return {
        title: 'Vehicles',
        filters: {
          columns: [
            {
              class: 'col-12 col-lg-6',
              filters: [
                {
                  name: 'reference',
                  label: this.$gettext('Reference'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return [[ 'reference', 'ct', val.trim() ]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'plate-number',
                  label: this.$gettext('Plate Number'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return [[ 'plate_number', 'ct', val.trim() ]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-12 col-lg-6',
              filters: [
                {
                  name: 'vehicle-type',
                  label: this.$gettext('Vehicle Type'),
                  type: 'checkbox-group',
                  options: this.vehicleTypesSelect,
                  value: [],
                  stacked: true,
                  callback: (val) => {
                    if (val.length > 0) {
                      return [[ 'vehicle_type_id', 'in', val ]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'enabled',
                  label: this.$gettext('Enabled/Disabled'),
                  type: 'radio-group',
                  options: [
                    {
                      text: this.$gettext('All'),
                      value: null
                    },
                    {
                      text: this.$gettext('Enabled'),
                      value: '1'
                    },
                    {
                      text: this.$gettext('Disabled'),
                      value: '0'
                    }
                  ],
                  value: null,
                  stacked: false,
                  callback: (val) => {
                    if (val === '1') {
                      return [['active', 'eq', val]]
                    } else if (val === '0') {
                      return [['active', 'eq', 'false']]
                    } else {
                      return []
                    }
                  }
                }
              ]
            }
          ]
        }
      }
    }
  }
}
